import {Directive, ElementRef, HostListener, inject, output} from '@angular/core';

/**
 * Directive that detects clicks outside the host element and emits an event.
 *
 * @output {EventEmitter<void>} clickOutside - Emitted when a click occurs outside the element
 */
@Directive({
  selector: '[clickOutside]',
  standalone: true
})
export class ClickOutsideDirective {
  clickOutside = output();

  private elementRef = inject(ElementRef);

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: any) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
